import React from 'react';
import '../TermsOfUse/staticContent.less';
import Heading from '../common/Heading';
import StaticHeader from '../StaticHeader';

const GDPRCompliance = () => {
  return (
    <>
      <StaticHeader />
      <div className="staticBoxMain">
        <div className="statiContentBox">
          <Heading title="GDPR compliance" className="staticMainTitle text-center mb-50" />

          <div className="staticContentWrapper">
            <div className="staticList">
              <ul>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s,Lorem Ipsum is simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the
                  1500s,Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                  the industry's standard dummy text ever since the 1500s,
                </li>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s,Lorem Ipsum is simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the
                  1500s,
                </li>
                <li>
                  Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                  industry's standard dummy text ever since the 1500s,Lorem Ipsum is simply dummy text of the printing
                  and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the
                  1500s,Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                  the industry's standard dummy text ever since the 1500s,
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GDPRCompliance;
